'use strict';
angular.module('schoolLinqApp').factory('ipAccessService', [
	'$http',
	function ($http) {
		var endpoint = '/api/ipAccess';

		function get() {
			return $http.get(endpoint);
		}

		function postIP(ip) {
			return $http.post(endpoint, ip);
		}

		function deleteIP(id) {
			return $http.delete(endpoint, { params: { id: id } });
		}

		return {
			get: get,
			postIP: postIP,
			deleteIP: deleteIP,
		};
	},
]);
